module.exports = __webpack_public_path__ + "img/checkout_complete.77eacb04.svg";